const math = require('mathjs');
import _ from 'lodash';
import store from '../store';

let kuaibiPercent = 10;

const retainWan = (num, unit = 2, isPopulation = false,defaultValue) => {
  if((typeof num === 'undefined') || (num === null) || Number(num) === -1) return defaultValue;
  const val = Math.abs(Number(num)) // 取原始绝对值
  if (isNaN(val)) return num // 非数字返回原始
  const sign = Number(num) >= 0 // true = 正 false = 负
  if (val === 100000 && isPopulation)  return `${sign ? '' : '-'}10万+`
  if (val === 1000000 && isPopulation) return `${sign ? '' : '-'}100万+`;
  if (val >= 100000000)  return `${sign ? '' : '-'}${(val / 100000000).toFixed(unit)}亿`;
  else if (val >= 10000) return `${sign ? '' : '-'}${(val / 10000).toFixed(unit)}万`;
  else return `${sign ? '' : '-'}${val % 1 ? val.toFixed(unit) : val}`; // 判断是否为小数
};
/**
 * 单位换算，将数字和后缀分开返回
 * @param {number} num
 * @param {object} options
 * @param {number} options.decimal - 保留小数位数
 * @param {boolean} options.isPopulation - 人数最高只能取到10万
 * @returns {{unit: string, num: string}|*}
 */
const splitWan = (num, options = { decimal: 2, isPopulation: false }) => {
  if (isNaN(num)) {
    return { num, unit: '' }
  }
  if (options.isPopulation) {
    if (Math.abs(num) === 100000) {
      return { num: 10, unit: '万+' };
    }
    if (Math.abs(num) === 1000000) {
      return { num: 100, unit: '万+' };
    }
  }
  if (Math.abs(num) >= 100000000) {
    return { num: (num / 100000000).toFixed(options.decimal), unit: '亿' };
  }
  if (Math.abs(num) >= 10000) {
    return { num: (num / 10000).toFixed(options.decimal), unit: '万' };
  }
  if (num === 0 || num === '0.00') {
    return { num: 0, unit: '' };
  }
  return { num, unit: '' };
};

const splitCoin = num => {
  if (isNaN(num)) {
    return num;
  } else {
    return splitWan(num / kuaibiPercent);
  }
};

const kuaibiCoin = val => {
  if (!isNaN(val)) {
    return retainWan(val / kuaibiPercent);
  } else {
    return val;
  }
};
/**
 * 计算持续时间
 * @param {number} unix
 * @param { {h:boolean, m:boolean, s:boolean} } show - 不展示传 false，其他展示的也得传 true
 * @returns {string}
 */
const dateLongDuration = (unix = 0, show = { h: true, m: true, s: true }) => {
    if (!unix || isNaN(unix)) {
        return '-'
    }

    let h = parseInt(unix / 3600);
    let m = parseInt(unix % 3600 / 60);
    let s = unix % 60;

    const format = (num, scale, show) => show ? num + scale : ''
    return `${h ?format(h, '时', show.h):''}${format(m, '分', show.m)}${format(s, '秒', show.s)}`;
};
const dateLong = val => {
  let dateLong = val.endTime - val.startTime;
  let showH = Math.floor(dateLong / 3600);
  let showM = Math.floor((dateLong % 3600) / 60);
  let showS = dateLong % 60;
  let { h, m, s } = val;
  const returnDate = (val, scale, show) => {
    return val && show ? `${val}${scale}` : '';
  };
  return dateLong
    ? `${showH ? returnDate(showH, '时', h) : ''}${showM ? returnDate(showM, '分', m) : ''}${showS ? returnDate(showS, '秒', s) : ''
    }`
    : '-';
};

const someDaysBetween = (val = { start: 1, end: 1 }) => {
  return `{"$between": [${moment()
    .subtract(val.start, 'days')
    .startOf('days')
    .unix()}, ${moment()
    .subtract(val.end, 'days')
    .endOf('days')
    .unix()}]}`;
};

const indentation = val => {
  let num = Math.abs(val);
  return `${val >= 0 ? '' : '-'}${num >= 10000 ? `${(num / 10000).toFixed(0)}w` : num}`;
};

const sum = (...arr) =>
  Number(
    []
      .concat(...arr)
      .reduce((acc, val) => math.format(math.add(math.bignumber(acc), math.bignumber(val || 0))), 0)
  );

const sixTable = (val, key, value) => {
  let effectiveData = val.filter(ele => {
    return _.get(ele, value);
  });
  let other = effectiveData.filter(ele => {
    return _.get(ele, key) === '其他';
  });
  let effectiveDataNoOther = effectiveData.filter(ele => {
    return _.get(ele, key) !== '其他';
  });
  let header = _.dropRight(effectiveDataNoOther, effectiveDataNoOther.length - 5);
  let footer = _.drop(effectiveDataNoOther, 5);
  let newObj = {};
  _.set(newObj, key, '其他');
  if (header.length === 5 && footer.length > 0) {
    _.set(
      newObj,
      value,
      sum(
        footer.map(ele => {
          return Number(_.get(ele, value, 0));
        })
      ).toFixed(2)
    );
  }
  if (other.length > 0) {
    _.set(newObj, value, Number(_.get(newObj, value) || 0) + _.get(other[0], value));
  }
  return effectiveData.length > 5 ? header.concat([newObj]) : effectiveData;
};

export const returnMax = val => {
  let defaultNum = Math.floor(Math.log10(val) / 1).toFixed(2);
  let a = Math.pow(10, Math.log10(val) % 1).toFixed(2);
  let firstDigit = '';
  let newChoose = val => {
    if (val < 6) {
      if (val >= 2 && val <= 2.5) {
        firstDigit = 2.5;
      } else {
        firstDigit = Math.ceil(val);
      }
    } else {
      firstDigit = 10;
    }
  };
  newChoose(a);
  if (firstDigit * Math.pow(10, defaultNum) < 5 && firstDigit !== 2.5) {
    firstDigit = 5;
  } else if (firstDigit === 1) {
    firstDigit = 10;
    defaultNum = defaultNum - 1;
  } else {
  }
  return [firstDigit * Math.pow(10, defaultNum), firstDigit, Math.pow(10, defaultNum)];
};

export const getInterval = data => {
  let max = JSON.parse(JSON.stringify(data)).sort(function (a, b) {
    return b[1] - a[1];
  })[0][1];
  return data.map(ele => {
    let multiple = max / ele[1];
    if (multiple >= 4) {
      ele[1] = max / 4;
    } else if (multiple >= 2) {
      ele[1] = max / 2;
    } else {
      ele[1] = max;
    }
    return ele[1] * ele[2];
  });
};
const goTop = () => {
  let currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
  let onceLength = currentPosition / 100;
  let timer;
  let gotoTop = function () {
    let nowLength = (document.documentElement.scrollTop || document.body.scrollTop) - onceLength;
    if (nowLength > 0) {
      window.scrollTo(0, nowLength);
    } else {
      window.scrollTo(0, 0);
      clearInterval(timer);
      timer = null;
    }
  };
  timer = setInterval(gotoTop, 1);
};

const updatedAtTime = val => {
  if (
    moment().unix() <
    moment()
      .startOf('day')
      .unix() +
    6 * 60 * 60
  ) {
    return `${val}${moment()
      .subtract(1, 'days')
      .hour(6)
      .minute(0)
      .format('MM-DD HH:mm')}`;
  } else {
    return `${val} ${moment()
      .hour(8)
      .minute(0)
      .format('MM-DD HH:mm')}`;
  }
};

const returnPosition = sourceType => {
  return `background-position: ${_.get(
    store.state.sourceIconPosition[sourceType],
    'position'
  )}rem 0`;
};

const checkMobilTypeof = () => {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return {
    isAndroid,
    isIOS
  };
};
const removeWxShare = () => {
  document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    WeixinJSBridge.call('hideOptionMenu');
  });
};
const getImage = (src, crossOrigin = true) => {
  let image = new Image();
  if (crossOrigin) {
    image.setAttribute('crossOrigin', 'Anonymous');
  }
  image.src = src;
  return new Promise((resolve, reject) => {
    image.onload = () => {
      console.log('dowmload-success');
      resolve(image);
    };
  });
};

const percentage = n => {
  const num = Number(n);
  if (num) {
    return (num * 100).toFixed(2) + '%';
  } else {
    return '-';
  }
};

// 基本上所有的 webp 图片都会在 cdn 上存一份 jpg 备份，统一修改后缀
const changeCDN = (url = 'https://s6.bihukankan.com/common/default.png') => {
  if (!!url) {
    return url.replace('webp', 'jpg');
  } else {
    // 传参为 '' 时 onerror 会无限循环
    return 'https://s6.bihukankan.com/common/default.png';
  }
}

const formatTime = (unix, template = 'YYYY-MM-DD HH:mm:ss') => moment(unix).format(template);

export {
  retainWan,
  splitWan,
  splitCoin,
  dateLong,
  someDaysBetween,
  indentation,
  sum,
  sixTable,
  goTop,
  updatedAtTime,
  returnPosition,
  checkMobilTypeof,
  kuaibiCoin,
  removeWxShare,
  getImage,
  percentage,
  changeCDN,
  formatTime,
    dateLongDuration

};
